(() => {
  const initializedTables = new WeakSet();
  const fractions = { '¼': .25, '½': .5, '¾': .75, '⅛': .125, '⅜': .375, '⅝': .625, '⅞': .875, '⅓': 1 / 3, '⅔': 2 / 3 };
  const parseMeasurement = (text) => {
    const value = text.trim();
    const range = value.split(/\s*[–—-]\s*/);
    if (range.length === 2) {
      const ends = range.map(parseMeasurement);
      return ends.every(end => typeof end === 'number') ? ends : null;
    }
    if (/^\d+(?:\.\d+)?$/.test(value)) return Number(value);
    const fraction = value.match(/^(\d+)\s*([¼½¾⅛⅜⅝⅞⅓⅔])$/);
    if (fraction) return Number(fraction[1]) + fractions[fraction[2]];
    const mixed = value.match(/^(?:(\d+)\s+)?(\d+)\/(\d+)$/);
    if (mixed && Number(mixed[3])) return Number(mixed[1] || 0) + Number(mixed[2]) / Number(mixed[3]);
    return null;
  };
  function prepareTables(root, words) {
    for (const table of root.querySelectorAll('[data-rr-sizing-content] table')) {
      if (initializedTables.has(table)) continue;
      initializedTables.add(table);
      const headings = Array.from(table.querySelectorAll('thead th'));
      const columns = headings.map((h, index) => /\(in\)/i.test(h.textContent) ? index : -1).filter(index => index >= 0);
      for (const heading of headings) heading.scope = 'col';
      if (!columns.length) continue;
      const entries = [];
      for (const row of table.querySelectorAll('tbody tr')) {
        for (const column of columns) {
          const cell = row.cells[column];
          const numeric = cell && parseMeasurement(cell.textContent);
          if (numeric === null || numeric === undefined) continue;
          entries.push({ cell, original: cell.textContent, numeric });
        }
      }
      if (!entries.length) continue;
      const originalHeadings = headings.map(h => h.textContent);
      const controls = document.createElement('div');
      controls.className = 'rr-unit-controls';
      controls.setAttribute('role', 'group');
      controls.setAttribute('aria-label', words.units);
      for (const unit of ['in', 'cm']) {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = unit === 'in' ? words.inches : words.centimeters;
        button.setAttribute('aria-pressed', String(unit === 'in'));
        button.addEventListener('click', () => {
          for (const control of controls.children) control.setAttribute('aria-pressed', String(control === button));
          for (const entry of entries) entry.cell.textContent = unit === 'in' ? entry.original : (Array.isArray(entry.numeric) ? entry.numeric.map(value => Math.round(value * 25.4) / 10).join('–') : String(Math.round(entry.numeric * 25.4) / 10));
          for (const index of columns) headings[index].textContent = unit === 'in' ? originalHeadings[index] : originalHeadings[index].replace(/\(in\)/i, '(cm)');
        });
        controls.append(button);
      }
      table.before(controls);
      const help = document.createElement('p');
      help.className = 'rr-measurement-help';
      help.textContent = words.measure;
      if (headings.some(heading => /width/i.test(heading.textContent))) table.after(help);
      for (const heading of headings) heading.scope = 'col';
    }
  }
  function start() {
    const wordsElement = document.querySelector('[data-rr-refinement-translations]');
    if (!wordsElement) return;
    const words = JSON.parse(wordsElement.textContent);
    const picker = document.querySelector('variant-picker[data-template-product-match="true"]');
    const root = picker?.closest('.shopify-section') || document.querySelector('.product-information')?.closest('.shopify-section');
    if (!root) return;
    function sync() {
      prepareTables(root, words);
      const currentPicker = root.querySelector('variant-picker[data-template-product-match="true"]');
      const needsSize = currentPicker?.dataset.rrSizeChosen === 'false';
      for (const label of root.querySelectorAll('[data-rr-purchase-label]')) {
        const button = label.closest('button');
        const target = needsSize && !button.disabled ? words.choose : label.dataset.rrPurchaseLabel;
        if (label.textContent !== target) label.textContent = target;
      }
      const variantTitle = root.querySelector('.sticky-add-to-cart__variant');
      if (needsSize && variantTitle) {
        const matrix = currentPicker.querySelector('[data-rr-variant-matrix]');
        if (matrix) {
          const data = JSON.parse(matrix.textContent);
          const options = data.options.map((name, i) => /^size$/i.test(name) ? words.choose : data.selected[i]);
          const title = options.join(' / ');
          if (variantTitle.textContent !== title) variantTitle.textContent = title;
        }
      }
    }
    const observer = new MutationObserver(sync);
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-rr-size-chosen', 'disabled'] });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

